<template>
  <div class="tax-table-wrap tax-table-wrap-tax53" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
    <dl class="tax-table-header">
      <dt>职工薪酬支出及纳税调整明细表</dt>

      <dd></dd>
    </dl>

    <div class="tax-table-body">
      <table border="1" cellspacing="0" cellpadding="4" tabletype="2024033111">
        <thead>
          <tr>
            <td rowspan="2" class="title01" style="width: 5%">行次</td>
            <td rowspan="2" class="title01" style="width: 15%; letter-spacing: 5px">项目</td>
            <td class="title01" style="width: 10%">账载金额</td>
            <td class="title01" style="width: 10%">实际发生额</td>
            <td class="title01" style="width: 8%">税收规定<br />扣除率</td>
            <td class="title01" style="width: 10%">以前年度<br />累计结转扣除额</td>
            <td class="title01" style="width: 10%">税收金额</td>
            <td class="title01" style="width: 10%">纳税调整金额</td>
            <td class="title01" style="width: 10%">累计结转以后年度扣除额</td>
          </tr>
          <tr>
            <td class="title01">1</td>
            <td class="title01">2</td>
            <td class="title01">3</td>
            <td class="title01">4</td>
            <td class="title01">5</td>
            <td class="title01">6（1-5）</td>
            <td class="title01">7（2+4-5）</td>
          </tr>
        </thead>
        <tbody>
          <tr class="tr">
            <td>1</td>
            <td class="title01">一、工资薪金支出</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v1x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v1x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v1x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v1x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v1x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v1x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">{{ parseFloatNum(data.v1x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">2</td>
            <td class="td_l title01" style="padding-left: 28px">其中：股权激励</td>
            <td class="d1"><el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5"><el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v2x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">3</td>
            <td class="td_l title01">二、职工福利费支出</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v3x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v3x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">
                {{ new Big(data.v3x3.value).times(100) }}
                <span style="margin-left: 3px">%</span>
              </div>
            </td>
            <td class="d4">--</td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v3x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v3x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v3x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v3x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">{{ parseFloatNum(data.v3x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">4</td>
            <td class="td_l title01">三、职工教育经费支出</td>
            <td class="d1">
              {{ parseFloatNum(data.v4x1.value) }}
              <!-- 考题 -->
              <!-- <taxQue :data="data.v4x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v4x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue> -->
            </td>
            <td class="d2">
              {{ parseFloatNum(data.v4x2.value) }}
              <!-- 考题 -->
              <!-- <taxQue :data="data.v4x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v4x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue> -->
            </td>
            <td class="d3">--</td>
            <td class="d4">
              {{ parseFloatNum(data.v4x4.value) }}
            </td>
            <td class="d5">
              {{ parseFloatNum(data.v4x5.value) }}
              <!-- 考题 -->
              <!-- <taxQue :data="data.v4x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v4x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue> -->
            </td>
            <td class="d6">
              {{ parseFloatNum(data.v4x6.value) }}
              <!-- 考题 -->
              <!-- <taxQue :data="data.v4x6" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v4x6.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue> -->
            </td>
            <td class="d7">
              {{ parseFloatNum(data.v4x7.value) }}
              <!-- 考题 -->
              <!-- <taxQue :data="data.v4x7" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v4x7.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v4x7.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v4x7.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue> -->
            </td>
          </tr>

          <tr class="tr">
            <td class="title01">5</td>
            <td class="td_l title01" style="padding-left: 28px">其中：按税收规定比例扣除的职工教育经费</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v5x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v5x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">
                {{ new Big(data.v5x3.value).times(100) }}
                <span style="margin-left: 3px">%</span>
              </div>
            </td>
            <td class="d4"><el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v5x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v5x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v5x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v5x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">{{ parseFloatNum(data.v5x6.value) }}</td>
            <td class="d7">{{ parseFloatNum(data.v5x7.value) }}</td>
          </tr>

          <tr class="tr">
            <td class="title01">6</td>
            <td class="td_l title01" style="padding-left: 66px">按税收规定全额扣除的职工培训费用</td>
            <td class="d1"><el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">
                {{ new Big(data.v6x3.value).times(100) }}
                <span style="margin-left: 3px">%</span>
              </div>
            </td>
            <td class="d4">--</td>
            <td class="d5"><el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v6x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">7</td>
            <td class="td_l title01">四、工会经费支出</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v7x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v7x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">
                {{ new Big(data.v7x3.value).times(100) }}
                <span style="margin-left: 3px">%</span>
              </div>
            </td>
            <td class="d4">--</td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v7x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v7x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">
              <!-- 考题 -->
              <taxQue :data="data.v7x6" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v7x6.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v7x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v7x6.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">8</td>
            <td class="td_l title01">五、各类基本社会保障性缴款</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v8x1" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x1.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v8x2" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x2.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d3">--</td>
            <td class="d4">--</td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v8x5" :mode="mode">
                <template #input>
                  <el-input-number v-model.trim="data.v8x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" />
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v8x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number placeholder="分值" class="score-wrap-score" v-model.trim="data.v8x5.score" :controls="false" :precision="1" :step="0.1" :max="100" :min="0" :value-on-clear="null" />
                </template>
              </taxQue>
            </td>
            <td class="d6">{{ parseFloatNum(data.v8x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">9</td>
            <td class="td_l title01">六、住房公积金</td>
            <td class="d1"><el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">--</td>
            <td class="d4"><el-input-number v-model.trim="data.v9x4.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d5"><el-input-number v-model.trim="data.v9x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v9x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">10</td>
            <td class="td_l title01">七、补充养老保险</td>
            <td class="d1"><el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">
                {{ new Big(data.v10x3.value).times(100) }}
                <span style="margin-left: 3px">%</span>
              </div>
            </td>
            <td class="d4">--</td>
            <td class="d5"><el-input-number v-model.trim="data.v10x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v10x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">11</td>
            <td class="td_l title01">八、补充医疗保险</td>
            <td class="d1"><el-input-number v-model.trim="data.v11x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v11x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">
                {{ new Big(data.v11x3.value).times(100) }}
                <span style="margin-left: 3px">%</span>
              </div>
            </td>
            <td class="d4">--</td>
            <td class="d5"><el-input-number v-model.trim="data.v11x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v11x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">12</td>
            <td class="td_l title01">九、其他</td>
            <td class="d1"><el-input-number v-model.trim="data.v12x1.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d2"><el-input-number v-model.trim="data.v12x2.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d3">
              <div style="display: flex; align-items: center; justify-content: center">--</div>
            </td>
            <td class="d4">--</td>
            <td class="d5"><el-input-number v-model.trim="data.v12x5.value" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.0" /></td>
            <td class="d6">{{ parseFloatNum(data.v12x6.value) }}</td>
            <td class="d7">--</td>
          </tr>
          <tr class="tr">
            <td class="title01">13</td>
            <td class="td_l title01">合计（1+3+4+7+8+9+10+11+12）</td>
            <td class="d1">
              <!-- 考题 -->
              <taxQue :data="data.v13x1" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v13x1.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x1.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x1.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d2">
              <!-- 考题 -->
              <taxQue :data="data.v13x2" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v13x2.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x2.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x2.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d3">--</td>
            <td class="d4">{{ parseFloatNum(data.v13x4.value) }}</td>
            <td class="d5">
              <!-- 考题 -->
              <taxQue :data="data.v13x5" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v13x5.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x5.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x5.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d6">
              <!-- 考题 -->
              <taxQue :data="data.v13x6" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v13x6.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x6.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x6.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
            <td class="d7">
              <!-- 考题 -->
              <taxQue :data="data.v13x7" :mode="mode">
                <template #input>
                  {{ parseFloatNum(data.v13x7.value) }}
                </template>
                <template #score>
                  <el-input-number placeholder="答案" class="score-wrap-answer" v-model.trim="data.v13x7.answer" :controls="false" :precision="2" :step="0.01" :value-on-clear="null" />
                  <el-input-number
                    placeholder="分值"
                    class="score-wrap-score"
                    v-model.trim="data.v13x7.score"
                    :controls="false"
                    :precision="1"
                    :step="0.1"
                    :max="100"
                    :min="0"
                    :value-on-clear="null"
                  />
                </template>
              </taxQue>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { cloneDeep, includes } from "lodash";
import Big from "big.js";
import { reportTaxDateConfig } from "../../reportTaxStaticConfig.js";
import taxQue from "../../cmp/taxQue.vue";
import { syncAnswer } from "../../cmjs/index.js";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
  mode.value = options.mode;
  taxDataAll.value = cloneDeep(options.taxDataAll);
  // 当前数据
  taxData.value = cloneDeep(options.taxData);
  // 当前数据的表单数据
  data.value = cloneDeep(options.taxData.data);
  watchStart();
  isInit.value = true;
};
// 返回数据
const getData = () => {
  if (!isInit.value) {
    return;
  }

  return toRaw(data.value);
};

const watchData = computed(() => cloneDeep(data.value));
function watchStart() {
  watch(
    watchData,
    (newVal, oldVal) => {
      try {
        for (let row = 1; row <= 12; row++) {
          // 1-12行 6列=1列-5列
          data.value[`v${row}x6`].value = new Big(data.value[`v${row}x1`].value).minus(data.value[`v${row}x5`].value).round(2).toNumber();
          // 5行 7列=2列+4列-5列
          if ([5].includes(row)) {
            data.value[`v${row}x7`].value = new Big(data.value[`v${row}x2`].value).plus(data.value[`v${row}x4`].value).minus(data.value[`v${row}x5`].value).round(2).toNumber();
          }
        }

        for (let column = 1; column <= 7; column++) {
          // 1-6列 13行=1+3+4+7+8+9+10+11+12
          if (column != 3) {
            let res1 = new Big(0);
            for (let row = 1; row <= 12; row++) {
              if (![2, 5, 6].includes(row)) {
                res1 = res1.plus(data.value[`v${row}x${column}`].value);
              }
            }

            data.value[`v13x${column}`].value = res1.round(2).toNumber();
          }

          // 4行=5行+6行
          if (column != 3) {
            data.value[`v4x${column}`].value = new Big(data.value[`v5x${column}`].value).plus(data.value[`v6x${column}`].value).round(2).toNumber();
          }
        }

        // 第3行第5列计算逻辑：用第1行第5列的数据乘以第3行第3列的数据的结果，跟第3行第2列的数据作比较，谁小取谁
        data.value.v3x5.value = Math.min(new Big(data.value.v1x5.value).times(data.value.v3x3.value).round(2).toNumber(), new Big(data.value.v3x2.value).round(2).toNumber());

        // 第5行第5列数据计算逻辑：用第1行第5列数据乘以第5行第3列数据的结果，跟第5行第2列加第5行第4列的和作比较，谁小取谁。
        data.value.v5x5.value = Math.min(new Big(data.value.v1x5.value).times(data.value.v5x3.value).round(2).toNumber(), new Big(data.value.v5x2.value).plus(data.value.v5x4.value).round(2).toNumber());

        // 第7行第5列数据计算逻辑：用第1行第5列数据乘以第7行第3列数据的结果，跟第7行第2列的数据作比较，谁小取谁。
        data.value.v7x5.value = Math.min(new Big(data.value.v1x5.value).times(data.value.v7x3.value).round(2).toNumber(), new Big(data.value.v7x2.value).round(2).toNumber());

        syncAnswer({
          mode,
          newVal,
          oldVal,
          data,
        });
      } catch (e) {
        console.log(e);
      }
    },
    {
      deep: true,
      immediate: true,
    }
  );
}

// 小数点
function parseFloatNum(s, num = 2) {
  try {
    return new Big(s).toFixed(num);
  } catch (e) {}
}

defineExpose({
  init,
  getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
  width: 1200px !important;
  table {
    tbody {
      tr {
        td {
          &:nth-of-type(2) {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

<script>
const tableHtml = `
<table border="1" cellspacing="0" cellpadding="4" tabletype="2024033111">
  <thead>
    <tr>
      <td rowspan="2" class="title01" style="width: 5%">行次</td>
      <td rowspan="2" class="title01" style="width: 25%; letter-spacing: 5px">项目</td>
      <td class="title01" style="width: 10%">账载金额</td>
      <td class="title01" style="width: 10%">实际发生额</td>
      <td class="title01" style="width: 7%">税收规定扣除率</td>
      <td class="title01" style="width: 7%">以前年度累计结转扣除额</td>
      <td class="title01" style="width: 10%">税收金额</td>
      <td class="title01" style="width: 10%">纳税调整金额</td>
      <td class="title01" style="width: 10%">累计结转以后年度扣除额</td>
    </tr>
    <tr>
      <td class="title01">1</td>
      <td class="title01">2</td>
      <td class="title01">3</td>
      <td class="title01">4</td>
      <td class="title01">5</td>
      <td class="title01">6（1-5）</td>
      <td class="title01">7（2+4-5）</td>
    </tr>
  </thead>
  <tbody>
    <tr class="tr">
      <td>1</td>
      <td class="title01">一、工资薪金支出</td>
      <td class="d1"><input type="text" value="0" class="i1 num j1 input2" daan="3289810.44" qc="1" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j1 input2" daan="3289810.44" /></td>
      <td class="d3">--</td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j1 input2" daan="3289810.44" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j1 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">2</td>
      <td class="td_l title01">其中：股权激励</td>
      <td class="d1"><input type="text" value="0" class="i1 num j2 input2" daan="0.00" qc="1" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j2 input2" daan="0.00" /></td>
      <td class="d3">--</td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j2 input2" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j2 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">3</td>
      <td class="td_l title01">二、职工福利费支出</td>
      <td class="d1"><input type="text" value="0" class="i1 num j3 input2" daan="149650.03" qc="1" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j3 input2" daan="149650.03" /></td>
      <td class="d3"><input type="text" value="14%" class="i3 j3 input1" daan="0.00" /></td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j3 input2" daan="149650.03" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j3 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">4</td>
      <td class="td_l title01">三、职工教育经费支出</td>
      <td class="d1"><input type="text" value="0" class="i1 num j4 input1" daan="271026.42" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j4 input1" daan="271026.42" /></td>
      <td class="d3">--</td>
      <td class="d4"><input type="text" value="0" class="i4 num j4 input1" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num j4 input1" daan="263184.84" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j4 input1" daan="7841.58" /></td>
      <td class="d7"><input type="text" value="0" class="i7 num j4 input1" daan="7841.58" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">5</td>
      <td class="td_l title01">其中：按税收规定比例扣除的职工教育经费</td>
      <td class="d1"><input type="text" value="0" class="i1 num j5 input2" daan="271026.42" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j5 input2" daan="271026.42" /></td>
      <td class="d3"><input type="text" value="8%" class="i3 j5 input1" daan="0.00" /></td>
      <td class="d4"><input type="text" value="0" class="i4 num j5 input1" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num j5 input2" daan="263184.84" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j5 input1" daan="7841.58" /></td>
      <td class="d7"><input type="text" value="0" class="i7 num j5 input1" daan="7841.58" /></td>
    </tr>
    <tr class="tr">
      <td class="title01">6</td>
      <td class="td_l title01">按税收规定全额扣除的职工培训费用</td>
      <td class="d1"><input type="text" value="0" class="i1 num j6 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j6 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="100%" class="i3 j6 input1" daan="0.00" /></td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j6 input1" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j6 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">7</td>
      <td class="td_l title01">四、工会经费支出</td>
      <td class="d1"><input type="text" value="0" class="i1 num j7 input2" daan="77603.87" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j7 input2" daan="77603.87" /></td>
      <td class="d3"><input type="text" value="2%" class="i3 j7 input1" daan="0.00" /></td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j7 input1" daan="65796.21" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j7 input1" daan="11807.66" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">8</td>
      <td class="td_l title01">五、各类基本社会保障性缴款</td>
      <td class="d1"><input type="text" value="0" class="i1 num j8 input2" daan="2804670.29" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j8 input2" daan="2804670.29" /></td>
      <td class="d3">--</td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j8 input2" daan="2804670.29" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j8 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">9</td>
      <td class="td_l title01">六、住房公积金</td>
      <td class="d1"><input type="text" value="0" class="i1 num j9 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j9 input2" daan="0.00" /></td>
      <td class="d3">--</td>
      <td class="d4"><input type="text" value="0" class="i4 num j9 input1" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 num j9 input2" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j9 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">10</td>
      <td class="td_l title01">七、补充养老保险</td>
      <td class="d1"><input type="text" value="0" class="i1 num j10 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j10 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="5%" class="i3 j10 input2" daan="0.00" /></td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j10 input1" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j10 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">11</td>
      <td class="td_l title01">八、补充医疗保险</td>
      <td class="d1"><input type="text" value="0" class="i1 num j11 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j11 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="5%" class="i3 j11 input2" daan="0.00" /></td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j11 input1" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j11 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">12</td>
      <td class="td_l title01">九、其他</td>
      <td class="d1"><input type="text" value="0" class="i1 num j12 input2" daan="0.00" /></td>
      <td class="d2"><input type="text" value="0" class="i2 num j12 input2" daan="0.00" /></td>
      <td class="d3"><input type="text" value="0" class="i3 j12 input1" daan="0.00" /></td>
      <td class="d4">--</td>
      <td class="d5"><input type="text" value="0" class="i5 num j12 input2" daan="0.00" /></td>
      <td class="d6"><input type="text" value="0" class="i6 num j12 input1" daan="0.00" /></td>
      <td class="d7">--</td>
    </tr>
    <tr class="tr">
      <td class="title01">13</td>
      <td class="td_l title01">合计（1+3+4+7+8+9+10+11+12）</td>
      <td class="d1"><input type="text" value="0" class="i1 j13 hj1 input1" daan="6592761.05" /></td>
      <td class="d2"><input type="text" value="0" class="i2 j13 hj2 input1" daan="6592761.05" /></td>
      <td class="d3">--</td>
      <td class="d4"><input type="text" value="0" class="i4 j13 hj4 input1" daan="0.00" /></td>
      <td class="d5"><input type="text" value="0" class="i5 j13 hj5 input1" daan="6573111.81" /></td>
      <td class="d6"><input type="text" value="0" class="i6 j13 hj6 input1" daan="19649.24" /></td>
      <td class="d7"><input type="text" value="0" class="i7 j13 hj7 input1" daan="7841.58" /></td>
    </tr>
  </tbody>
</table>
`;

function replaceHtml(str) {
  let s = str.replace(/(<div([^>]*)>)|(<\/div>)/gi, "");
  s = s.replace(/(<span([^>]*)>)|(<\/span>)/gi, "");
  s = s.replace(/<input.*type="text".*none.*>/g, "");
  s = s.replace(/<input.*type="text".*>/g, '<el-input-number v-model.trim="defaultValue" :controls="false" :precision="2" :step="0.01" :value-on-clear="0.00" />');

  return s;
}

const defaultValue = ref(0);
// console.log(replaceHtml(tableHtml), "tableHtml");
</script>
